import _ from "lodash";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import PatientCreator from "../utils/patient/new/PatientCreator";
import { ErrorAlert, Alert } from "../../utils";
import { useApi, useNavigate } from "../../utils/hooks";
import TitleHeadSess from "../../utils/TitleHeadSess";
import { Stack, Paper } from "@mui/material";

const NewPatient = () => {
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [shared, setShared] = useState(false);
  const onAlertClose = () => setError(null);

  const { url } = location.state || {
    url: "/",
  };

  const onSubmit = (patient) => {
    setLoading(true);
    api
      .createPatient(patient)
      .tap(() => setShared(true))
      .tap(() => setTimeout(() => navigate("/"), 3000))
      .catch(setError)
      .tap(() => setLoading(false));
  };

  return (
    <>
      <Stack
        width="100%"
        spacing="1rem"
        sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" } }}
      >
        <TitleHeadSess title={"Nuevo Paciente"} urlRedirect={url} />

        <Paper
          variant="outlined"
          width="100%"
          sx={{
            p: { xs: "20px 10px", sm: "20px 40px" },
            borderRadius: 3,
            mb: 7,
          }}
        >
          <PatientCreator
            onSubmit={onSubmit}
            loading={loading}
            title={"Datos del paciente"}
          />
        </Paper>
      </Stack>
      <ErrorAlert
        show={!_.isEmpty(error)}
        onClose={onAlertClose}
        message="No se pudo cargar al paciente en el sistema. Ya existe un paciente con este DNI"
      />
      <Alert
        severity="success"
        message="Los datos del paciente han sido guardados exitosamente."
        onClose={() => setShared(false)}
        show={shared}
      />
    </>
  );
};

export default NewPatient;
